// extracted by mini-css-extract-plugin
export default {"tabHeader":"TabHeader_tabHeader__ka3S7","tabIcon":"TabHeader_tabIcon__iuD6s","tabTitle":"TabHeader_tabTitle__bGA4w"};